let $filterItems;
let $searchInput;
let $sortInput;
let $resetFilters;
let $postsContainer;
let $filterContainer;
let $paginationContainer;
let $toggleFilters;
let $numPosts;
let $loaders;
let $pagination;
let $filterPopup;
let $toggleFilterPopup;
let $relatedPostContainer;
let $spinner;

let currentPage = 1;
let firstLoad = true;

let post_type;
let popup_status;
let sort_option;
let search_value;
let filters = [];
let listing_id;
let event_id;
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

// Fallback if linku_ajax_url is not defined (cache issue)
if (typeof linku_ajax_url === 'undefined') {
  console.warn('linku_ajax_url not defined, using fallback');
  window.linku_ajax_url = '/wp/wp-admin/admin-ajax.php';
}

$(document).ready(($) => {
  $postsContainer = $('.js-posts-container');
  $filterContainer = $('.js-filter-container');
  $paginationContainer = $('.js-pagination-container');
  $searchInput = $('.js-filter-search');
  $sortInput = $('.js-sort');
  $numPosts = $('.js-num-posts');
  $loaders = $('.js-loader');
  $relatedPostContainer = $('.js-related-posts');
  $spinner = $('.c-related-loader__spinner');

  getUrlParams();

  if ($postsContainer.length !== 0 && firstLoad) {
    post_type = $postsContainer.data('pt');

    // Set initial sort
    if (search_value === '' && $sortInput.val() === 'relevance_desc') {
      sort_option = 'date_desc';
    } else {
      sort_option = $sortInput.val();
    }

    // Set inital search
    // search_value = $searchInput.val();
    initFunctions();
    getPosts();
    firstLoad = false;
  }

  $searchInput.on('keyup', (e) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      search();
    }
  });
});

function getPosts() {
  $loaders.addClass('is_loading');
  $.ajax({
    url: linku_ajax_url,
    type: 'post',
    data: {
      action: 'load_posts',
      post_type,
      filters,
      sort_option,
      search_value,
      paged: currentPage,
      popup_status,
      listing_id,
      event_id,
    },
    dataType: 'json',
    success(response) {
      $searchInput.val(search_value);
      $postsContainer.html(response.postsHtml);
      $filterContainer.html(response.filtersHtml);
      $paginationContainer.html(response.paginationHtml);
      setNumPosts(response.numPosts);
      if (typeof checkFavourites === 'function') {
        checkFavourites();
      }
      if (typeof checkAllListingConversations === 'function') {
        checkAllListingConversations();
      }
      $loaders.removeClass('is_loading');
      initFunctions();
      $('.real3dflipbook').each(function () {
        const fbdata = $(this).data('flipbook-options');
        $(this).flipBook({
          pdfUrl: fbdata.pdfUrl,
        });
      });
    },
    error(response) {
      console.log('error', response);
    },
  });
}

function initFunctions() {
  $filterItems = $('.js-filter-item');
  $toggleFilters = $('.js-toggle-filter');
  $resetFilters = $('.js-clear-filters');
  $pagination = $('.js-pagination');
  $toggleFilterPopup = $('.js-toggle-filter-popup');
  $filterPopup = $('.js-filter-popup');

  initReadMore();

  $filterItems.on('click', function () {
    const filter = $(this).data('filter');
    if (typeof filter === 'string' && filter.startsWith('listing_id.')) {
      listing_id = null;
      currentPage = 1;
      popup_status = !!$filterPopup.hasClass('is-open');
      getPosts();
      updateUrl();
      return;
    }
    if (typeof filter === 'string' && filter.startsWith('event_id.')) {
      event_id = null;
      currentPage = 1;
      popup_status = !!$filterPopup.hasClass('is-open');
      getPosts();
      updateUrl();
      return;
    }

    if ($(this)[0].type === 'radio') {
      filters = filters.filter((item) => !(item.includes($(this)[0].name)));
    }
    if (filters.includes(filter)) {
      filters = filters.filter((item) => item !== filter);
    } else {
      filters.push(filter);
    }

    popup_status = !!$filterPopup.hasClass('is-open');
    currentPage = 1;
    getPosts();
    updateUrl();
  });

  $resetFilters.on('click', (e) => {
    filters = [];
    listing_id = null;
    event_id = null;
    getPosts();
    updateUrl();
  });

  $toggleFilters.on('click', function (e) {
    e.stopPropagation();
    if ($(this).hasClass('is-open')) {
      $(this).removeClass('is-open');
      $(this).next().slideUp();
    } else {
      $(this).addClass('is-open');
      $(this).next().slideDown();
    }
  });
  // $toggleFilters.each(function(){
  //     console.log("gevonden", $(this).find('.is_selected').length !== 0);
  //     if($(this).find('.is_selected').length !== 0){
  //         $(this).addClass('is_open');
  //         $(this).next().slideDown();
  //     }
  // });

  $pagination.on('click', function (e) {
    $('html, body').animate({
      scrollTop: $postsContainer.offset().top - 200,
    }, 'slow');
    if ($(this).data().page === 'prev') {
      currentPage -= 1;
    } else if ($(this).data().page === 'next') {
      currentPage += 1;
    } else {
      currentPage = Number($(this).data().page);
    }
    getPosts();
    updateUrl();
  });

  $toggleFilterPopup.on('click', (e) => {
    $filterPopup.each(function () {
      if ($(this).hasClass('is-open')) {
        $body.removeClass('menu-is-open');
        $(this).fadeOut().removeClass('is-open');
      } else {
        $(this).fadeIn().addClass('is-open');
        $body.addClass('menu-is-open');
      }
    });
  });
}

function sortPosts(selected) {
  sort_option = selected.value;
  getPosts();
}

function search() {
  search_value = $searchInput.val();
  if (search_value === '') {
    sort_option = 'date_desc';
  } else {
    sort_option = $sortInput.val();
  }
  currentPage = 1;
  updateUrl();
  getPosts();
}

function setNumPosts(num) {
  const singular = $numPosts.data('singular');
  const plural = $numPosts.data('plural');
  const found = $numPosts.data('found');
  const placeholder = $numPosts.data('placeholder');
  const translations = window.linku_translations || { no: 'Geen', one: 'Eén' };
  let newString = '';
  if (num === -1) {
    newString = `${placeholder}.`;
  } else if (num === 0) {
    newString = `${translations.no} ${plural} ${found}.`;
  } else if (num === 1) {
    newString = `${translations.one} ${singular} ${found}.`;
  } else {
    newString = `${num} ${plural} ${found}.`;
  }

  $numPosts.html(newString);
}

function getUrlParams() {
  let termFilters = []; let posttypeFilters = []; let
    metaFilters = [];
  if (urlParams.has('term')) {
    termFilters = urlParams.getAll('term');
    for (const i in termFilters) {
      termFilters[i] = `term.${termFilters[i]}`;
    }
  }
  if (urlParams.has('posttype')) {
    posttypeFilters = urlParams.getAll('posttype');
    for (const i in posttypeFilters) {
      posttypeFilters[i] = `posttype.${posttypeFilters[i]}`;
    }
  }
  if (urlParams.has('post_meta')) {
    metaFilters = urlParams.getAll('post_meta');
    for (const i in metaFilters) {
      metaFilters[i] = `post_meta.${metaFilters[i]}`;
    }
  }
  filters = termFilters.concat(posttypeFilters, metaFilters);
  if (urlParams.has('page')) {
    currentPage = urlParams.get('page');
  }
  if (urlParams.has('s')) {
    search_value = urlParams.get('s');
  } else {
    search_value = '';
  }
  if (urlParams.has('listing_id')) {
    listing_id = urlParams.get('listing_id');
  }
  if (urlParams.has('event_id')) {
    event_id = urlParams.get('event_id');
  }
}

function updateUrl() {
  urlParams.delete('term');
  urlParams.delete('posttype');
  urlParams.delete('post_meta');
  urlParams.delete('s');
  urlParams.delete('listing_id');
  urlParams.delete('event_id');
  for (const i in filters) {
    const type = filters[i].split('.')[0];
    const value = filters[i].split('.').pop();
    urlParams.append(type, value);
  }
  if (search_value) {
    urlParams.set('s', search_value);
  }
  if (listing_id) {
    urlParams.set('listing_id', listing_id);
  }
  if (event_id) {
    urlParams.set('event_id', event_id);
  }
  urlParams.set('page', currentPage);
  window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);
}

function getRelatedPosts(currentPosttype, collectionPosttype, currentPostId) {
  $spinner.addClass('is-loading');
  $relatedPostContainer.css('display', 'none');
  $.ajax({
    url: linku_ajax_url,
    type: 'post',
    data: {
      action: 'get_collection',
      post_type: currentPosttype,
      post_id: currentPostId,
      collection_type: collectionPosttype.value,
    },
    dataType: 'json',
    success(response) {
      $relatedPostContainer.html(response.collectionHtml);
      $spinner.removeClass('is-loading');
      $relatedPostContainer.css('display', 'flex');
    },
    error(response) {
      console.log('error', response);
    },
  });
}

function getItemsFromCollection(select) {
  let itemCollection = [];
  try {
    itemCollection = JSON.parse(select.dataset.items || '[]');
  } catch (e) {
    itemCollection = [];
  }
  $spinner.addClass('is-loading');
  $relatedPostContainer.css('display', 'none');
  $.ajax({
    url: linku_ajax_url,
    type: 'post',
    data: {
      action: 'get_items_from_collection',
      collection: itemCollection,
      posttype: select.value,
    },
    dataType: 'json',
    success(response) {
      $relatedPostContainer.html(response.collectionHtml);
      $spinner.removeClass('is-loading');
      $relatedPostContainer.css('display', 'flex');
    },
    error(response) {
      console.log('error', response);
    },
  });
}

function initReadMore() {
  $readMore = $('.js-read-more');

  $readMore.each(function () {
    const readMore = $(this);
    const readMoreToggle = readMore.find('.js-read-more-toggle');
    const readMoreContent = readMore.find('.js-read-more-more');

    readMoreToggle.click((e) => {
      e.preventDefault();
      readMore.toggleClass('is-expanded');
      const isExpanded = readMore.hasClass('is-expanded');

      readMoreToggle.attr('aria-expanded', isExpanded);
      if (isExpanded) {
        readMoreToggle.text(readMore.data('read-less-text'));
        readMoreContent.removeClass('rs_skip');
      } else {
        readMoreToggle.text(readMore.data('read-more-text'));
        readMoreContent.addClass('rs_skip');
      }
    });
  });
}
